import React from 'react'
import styles from './validatedRadioInput.module.scss'

const ValidatedRadioInput = React.forwardRef((props, ref) => {
  const { onClick, selected, label, value, name } = props
  return (
    <div className={styles.container} onClick={() => onClick(value)}>
      <div className={styles.check}>
        {selected && <span className={styles.checked} />}
      </div>
      <label>{label}</label>
    </div>
  )
})
export default ValidatedRadioInput
